export class RoomImageModel {
    public id: number;
    public room_id: number;
    public title: string;
    public file_path: string;
    public file_type: string;
    public size: string;
    public is_banner: number;
    public created_at: string;
    public updated_at: string;
    public image_path: string;

    constructor(obj: any) {
        this.id = obj.id ? obj.id : 0;
        this.room_id = obj.room_id ? obj.room_id : 0;
        this.title = obj.title ? obj.title : '';
        this.file_path = obj.file_path ? obj.file_path : '';
        this.file_type = obj.file_type ? obj.file_type : '';
        this.size = obj.size ? obj.size : '';
        this.is_banner = obj.is_banner ? obj.is_banner : 0;
        this.created_at = obj.created_at ? obj.created_at : '';
        this.updated_at = obj.updated_at ? obj.updated_at : '';
        this.image_path = obj.image_path ? obj.image_path : '';
    }
}
